"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataLayerPush = dataLayerPush;
exports.declOfNum = declOfNum;

var _reactCookies = _interopRequireDefault(require("react-cookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Склонение слов
 * @example
 * declOfNum(['Яблоко','Яблока','Яблок'])(2); // Яблока
 * @param {array} titles
 * @returns {function(*=): *}
 */
function declOfNum(titles) {
  var cases = [2, 0, 1, 1, 1, 2];
  return function (number) {
    number = Math.abs(number);
    return titles[number % 100 > 4 && number % 100 < 20 ? 2 : cases[number % 10 < 5 ? number % 10 : 5]];
  };
}
/**
 * Отправка события в GA
 * @example
 * dataLayerPush({event: 'UAevent', category: 'sale', action: 'get gift'});
 * @param {JSON} params параметры события
 */


function dataLayerPush(params) {
  var abnVariant = _reactCookies["default"].load('abn_variant');

  params['ABNtest'] = abnVariant;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(params);
}